'use strict';

import angular from 'angular';
import PositionModalSvc from './modal/positionModal.service.js';

export default angular.module('georgeApp.position', [])
  .factory('PositionModalSvc', PositionModalSvc)
  .name;
